<template>
    <div class="odds-container">
        <div
            v-if="market.inPlayStatus && isInplayLive"
            class="d-flex align-center item-odds v-card v-card--flat v-sheet theme--light rounded-0 dark-border-racing"
        >
            <v-card
                v-if="!twoOdds"
                text
                tile
                color="white"
                class="text-capitalize d-flex text-left justify-space-between font-weight-bold flex-grow-1 flex-shrink-1 inplay-horse-details dark-border-racing"
                v-bind="$attrs"
                v-on="$listeners"
            >
                <div>{{ market.eventName }}</div>
                <div class="text-end event-spec-text">{{ market.name }}</div>
            </v-card>
        </div>
        <div
            v-if="market.bookMakerCustom && matchoddsBookmaker"
            class="caption pr-0 py-0 pl-0 v-expansion-panel-header"
        >
            <simple-bar
                hide-controls
                :title="market.name"
                :delay-time="market.betDelay"
                :bookmaker="market.bookMakerCustom"
                :bookmaker-commmission="
                    $auth.loggedIn &&
                    socketData.bookmakerCommission &&
                    $auth.user.bookmakerCommission > 0
                "
                :max-commission="maxCommission"
                :side-text="['Back', 'Lay']"
            ></simple-bar>
        </div>
        <template v-for="(runner, k) in markets">
            <v-card
                :key="`key-${k}`"
                class="d-flex align-center item-odds"
                dense
                light
                flat
                tile
                height="45"
                :class="{
                    'odds-strip': isInplayLive
                }"
            >
                <v-btn
                    v-if="!twoOdds"
                    text
                    tile
                    color="white"
                    class="text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1"
                    v-bind="$attrs"
                    v-on="$listeners"
                >
                    <div
                        class="black--text manage-overflow-two ranks"
                        :class="{
                            'mr-4': $breakpoint.mdAndUp,
                            'mr-2': $breakpoint.mdAndDown
                        }"
                    >
                        <div>1</div>
                        <div>(12)</div>
                    </div>
                    <span class="black--text manage-overflow-two">
                        {{ runner.name
                        }}<br
                            v-if="
                                runner &&
                                runner.metadata &&
                                runner.metadata.JOCKEY_NAME
                            "
                        />
                        <span class="subtitle">{{ runner.name }}</span>

                        <span v-if="$auth.loggedIn">
                            <br />
                            <!-- OLD BOOK -->
                            <span
                                v-if="books && books[market.betfairId]"
                                :class="{
                                    'green--text ':
                                        getBooks(books, runner.betfairId) > 0,
                                    'red--text':
                                        getBooks(books, runner.betfairId) < 0,
                                    'black--text ':
                                        getBooks(books, runner.betfairId) == 0
                                }"
                            >
                                {{
                                    (getBooks(books, runner.betfairId) /
                                        getMyRate())
                                        | currencyFormat(2)
                                }}
                            </span>
                            <!-- OLD BOOK -->

                            <!-- NEW BOOK -->
                            <span
                                v-if="newBooks && newBooks[market.betfairId]"
                                :class="{
                                    'green--text ':
                                        getBooks(books, runner.betfairId) +
                                            getBooks(
                                                newBooks,
                                                runner.betfairId
                                            ) >
                                        0,
                                    'red--text':
                                        getBooks(books, runner.betfairId) +
                                            getBooks(
                                                newBooks,
                                                runner.betfairId
                                            ) <
                                        0,
                                    'black--text ':
                                        getBooks(books, runner.betfairId) +
                                            getBooks(
                                                newBooks,
                                                runner.betfairId
                                            ) ==
                                        0
                                }"
                            >
                                <v-icon
                                    v-if="
                                        getBooks(books, runner.betfairId) &&
                                        getBooks(newBooks, runner.betfairId)
                                    "
                                    size="12"
                                    >mdi-chevron-right
                                </v-icon>
                                {{
                                    (getBooks(books, runner.betfairId) /
                                        getMyRate() +
                                        getBooks(newBooks, runner.betfairId))
                                        | currencyFormat(2)
                                }}
                            </span>
                            <!-- NEW BOOK -->
                        </span>
                    </span>
                </v-btn>
                <odds-disabled
                    v-if="
                        checkIfSuspended(market, runner, socketData) &&
                        betfairOddsCheck(market)
                    "
                    :text="checkIfSuspended(market, runner, socketData)"
                    :issideright="
                        market.bookMakerCustom || market.name === 'fancy'
                            ? 'rightsidebutton'
                            : ''
                    "
                    v-bind="$attrs"
                    v-on="$listeners"
                ></odds-disabled>

                <template
                    v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly, 'back')"
                >
                    <btn-odds
                        v-bind="$attrs"
                        v-if="
                            ((i === 0 && twoOdds) || !twoOdds) &&
                            betfairOddsCheck(market) &&
                            (!$auth.user ||
                                !(
                                    market.eventType.name === 'Cricket' &&
                                    $auth.user &&
                                    !$auth.user.matchOdds &&
                                    market.name.toLowerCase() === 'match odds'
                                ))
                        "
                        :key="'back' + key"
                        type="back"
                        :class="{
                            'opacity-0':
                                (i !== 0 && twoOdds) ||
                                (i !== 0 &&
                                    (market.bookmakerMultiOdds === false ||
                                        socketData.bookmakerMultiOdds ===
                                            false) &&
                                    bookmaker),
                            'flex-grow-1': twoOdds
                        }"
                        :disabled="
                            (i !== 0 && twoOdds) ||
                            !check(runner, 'batb', i, market)
                        "
                        @betData="
                            $store.commit('placeBet/openPopover', {
                                market,
                                runner,
                                allRunners: markets,
                                oddsIndex: i,
                                odds: market.bookMakerCustom
                                    ? getObjValue(runner.batb, 0, 2 - i, 1.01)
                                    : getObjValue(runner.batb, i, 1, 1.01),
                                type: 'back',
                                bettingType:
                                    market.bookMakerCustom &&
                                    market.isJodiMarket
                                        ? 'multiHorse'
                                        : market.bookMakerCustom &&
                                          !market.isJodiMarket
                                        ? 'bookmaker'
                                        : 'default'
                            })
                        "
                    >
                        <span
                            v-if="
                                market &&
                                market.bookMakerCustom &&
                                check(runner, 'batb', i, market)
                            "
                            class="d-block text-center position-relative"
                        >
                            {{
                                getObjValue(runner.batb, 0, 2 - i, "-")
                                    | currencyFormat(2)
                            }}
                        </span>

                        <span v-else>
                            <span
                                v-if="check(runner, 'batb', i)"
                                class="d-block text-center position-relative"
                            >
                                {{ getObjValue(runner.batb, i, 1, "-") }}
                            </span>
                            <span v-else class="d-block text-center">-</span>
                            <multiplyer
                                v-if="
                                    check(runner, 'batb', i) &&
                                    getObjValue(runner.batb, i, 2, 0)
                                "
                                :rates="getObjValue(runner.batb, i, 2, 0)"
                                :multiplyer="market.multiplyer"
                            ></multiplyer>
                        </span>
                    </btn-odds>
                </template>

                <template v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly)">
                    <btn-odds
                        v-bind="$attrs"
                        v-if="
                            ((i === 0 && twoOdds) || !twoOdds) &&
                            betfairOddsCheck(market) &&
                            (!$auth.user ||
                                !(
                                    market.eventType.name === 'Cricket' &&
                                    $auth.user &&
                                    !$auth.user.matchOdds &&
                                    market.name.toLowerCase() === 'match odds'
                                ))
                        "
                        :key="'lay' + key"
                        type="lay"
                        :class="{
                            'opacity-0':
                                (i !== 0 && twoOdds) ||
                                (i !== 0 &&
                                    (market.bookmakerMultiOdds === false ||
                                        socketData.bookmakerMultiOdds ===
                                            false) &&
                                    bookmaker),
                            'flex-grow-1': twoOdds
                        }"
                        :disabled="
                            (i !== 0 && twoOdds) ||
                            !check(runner, 'batl', i, market) ||
                            market.isOnlyback === 'Yes'
                        "
                        @betData="
                            $store.commit('placeBet/openPopover', {
                                market,
                                runner,
                                allRunners: markets,
                                oddsIndex: i,
                                odds: market.bookMakerCustom
                                    ? runner.batl[0][i]
                                    : runner.batl[i][1],
                                type: 'lay',
                                bettingType:
                                    market.bookMakerCustom &&
                                    market.isJodiMarket
                                        ? 'multiHorse'
                                        : market.bookMakerCustom &&
                                          !market.isJodiMarket
                                        ? 'bookmaker'
                                        : 'default'
                            })
                        "
                    >
                        <!-- {{ market.bookMakerCustom }}
                {{ check(runner, 'batl', i, market) }} -->
                        <span
                            v-if="
                                market &&
                                market.bookMakerCustom &&
                                check(runner, 'batl', i, market)
                            "
                            class="d-block text-center position-relative"
                        >
                            {{ runner.batl[0][i] | currencyFormat(2) }}
                        </span>
                        <span v-else>
                            <span
                                v-if="
                                    check(runner, 'batl', i) &&
                                    market.isOnlyback !== 'Yes'
                                "
                                class="d-block text-center position-relative"
                            >
                                <v-img
                                    v-show="
                                        runner.batl &&
                                        runner.batl[i].marketValueBatl == 'down'
                                    "
                                    :src="require('@/assets/images/down.png')"
                                    :lazy-src="
                                        require('@/assets/images/down.png')
                                    "
                                    max-width="10px"
                                    class="market-down-arrow"
                                ></v-img>
                                <v-img
                                    v-show="
                                        runner.batl &&
                                        runner.batl[i].marketValueBatl == 'up'
                                    "
                                    :src="require('@/assets/images/up.png')"
                                    :lazy-src="
                                        require('@/assets/images/up.png')
                                    "
                                    max-width="10px"
                                    class="market-up-arrow"
                                ></v-img>
                                {{ runner.batl[i][1] }}
                            </span>
                            <span v-else class="d-block text-center">-</span>
                            <multiplyer
                                v-if="
                                    check(runner, 'batl', i) &&
                                    market.isOnlyback !== 'Yes'
                                "
                                :rates="runner.batl[i][2]"
                                :multiplyer="market.multiplyer"
                            ></multiplyer>
                        </span>
                    </btn-odds>
                </template>
            </v-card>

            <bet-popover
                v-if="
                    $breakpoint.smAndDown &&
                    betslipOpener(
                        $auth,
                        $store,
                        runner.betfairId,
                        market.betfairId
                    )
                "
                :key="`p-${k}`"
                :check-id="runner.betfairId"
            ></bet-popover>
        </template>
        <!-- // eslint-disable-next-line vue/no-lone-template -->
        <template
            v-if="
                socketData.bookmakerMultiOdds === true &&
                bookmaker &&
                $auth.loggedIn &&
                !$breakpoint.xsOnly &&
                minmax.length
            "
        >
            <v-card
                class="d-flex align-center item-odds"
                dense
                flat
                tile
                height="55"
            >
                <v-btn
                    text
                    tile
                    color="white"
                    class="text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1"
                >
                    <span class="black--text manage-overflow-two">
                        Max Bet
                    </span>
                </v-btn>
                <template
                    v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly, 'back')"
                >
                    <div v-if="minmax && minmax[i].maxBet" :key="'back' + key">
                        <v-btn
                            class="btn-odds black--text font-weight-bold odds-width multiline-btn text-center didMutate px-1"
                            style="
                                font-size: 10px !important;
                                letter-spacing: 0px;
                                height: 40px;
                                margin: 1px;
                            "
                            small
                            tile
                            depressed
                        >
                            <span class="d-block text-center">
                                {{ minmax[i].maxBet }}
                            </span>
                        </v-btn>
                    </div>
                </template>

                <template v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly)">
                    <div v-if="minmax && minmax[i].maxBet" :key="'lay' + key">
                        <v-btn
                            class="btn-odds black--text font-weight-bold odds-width multiline-btn text-center didMutate px-1"
                            style="
                                font-size: 10px !important;
                                letter-spacing: 0px;
                                height: 40px;
                                margin: 1px;
                            "
                            small
                            tile
                            depressed
                        >
                            <span class="d-block text-center">
                                {{ minmax[i].maxBet }}
                            </span>
                        </v-btn>
                    </div>
                </template>
            </v-card>
        </template>
        <template
            v-if="
                market &&
                market.bookMakerCustom &&
                socketData.marketInputText &&
                socketData.marketId === marketId
            "
        >
            <v-divider></v-divider>
            <v-toolbar
                flat
                class="border-bottom-lr primary--text caption py-4"
                dense
                height="auto"
                >{{ socketData.marketInputText }}
            </v-toolbar>
        </template>
    </div>
</template>
<script>
import { mapState } from "vuex"
import upperFirst from "lodash/upperFirst"
import merge from "lodash/merge"
import cloneDeep from "lodash/cloneDeep"
import isString from "lodash/isString"
import forEach from "lodash/forEach"
import BtnOdds from "@/components/BtnOdds"
import OddsDisabled from "@/components/OddsDisabled"
import Multiplyer from "@/components/Multiplyer"
import BetPopover from "@/components/BetPopover"
import SimpleBar from "@/components/toolbars/SimpleBar"
import socket from "~/plugins/socket.client"
export default {
    name: "ItemsOdds",
    components: { BtnOdds, OddsDisabled, BetPopover, Multiplyer, SimpleBar },
    props: {
        market: { type: Object, default: () => {}, required: true },
        runners: { type: Array, default: () => [], required: true },
        twoOdds: { type: Boolean, default: false },
        matchoddsBookmaker: { type: Boolean, default: true },
        marketId: { type: [String, Number], default: 0, required: true },
        maxCommission: { type: Number, default: 0, required: false },
        bookmaker: { type: Boolean, default: false },
        bookmakerCommission: { type: Boolean, default: false },
        favoriteOdds: { type: Boolean, default: false },
        isInplayLive: { type: Boolean, default: false }
    },
    data() {
        return {
            gameMode: "SportsBook",
            markets: [],
            socketData: {},
            minmax: [],
            refresh: true
        }
    },

    computed: {
        ...mapState({
            books: (state) => state.betBooks.data,
            newBooks: (state) => state.betBooks.newData,
            matchIds: (state) => state.placeBet.matchIds,
            minMaxMarket: (state) => state.matchInside.minMaxMarket
        })
    },
    mounted() {
        this.markets = this.runners
        this.socketData.bookmakerCommission = this.market.bookmakerCommission
        if (this.marketId) {
            const socketMarketName = this.favoriteOdds
                ? `favouriteMarket_${this.marketId}`
                : this.marketId
            socket.rateSocket.on(socketMarketName, (data) => {
                this.socketData = data
                if (data.rates) {
                    this.markets = data.rates
                }
            })

            if (this.marketId.includes("bookmaker")) {
                socket.rateSocket.on("market_" + this.marketId, (data) => {
                    this.socketData = data
                    if (data.rates) {
                        this.markets = data.rates
                    }
                })
                socket.rateSocket.on("jodimarket_" + this.marketId, (data) => {
                    this.socketData = data
                    if (data.rates) {
                        this.markets = merge(this.markets, data.rates)
                    }
                })
            }
            if (this.marketId.includes("bookmaker") && this.$auth.loggedIn) {
                this.getMaxBet(this.markets)
            }
        }
    },
    created() {
        this.$root.$refs[this.marketId] = this
    },
    beforeDestroy() {
        socket.rateSocket.off(this.marketId)
        socket.rateSocket.off("favouriteMarket_" + this.marketId)
        socket.rateSocket.off("market_" + this.marketId)
        socket.rateSocket.off("jodimarket_" + this.marketId)
    },
    methods: {
        cashOut() {
            const market = cloneDeep(this.market)
            if (!this.$auth.loggedIn) {
                return this.$router.push({ name: "login" })
            } else if (
                !this.books[market.betfairId] ||
                this.books[market.betfairId]?.length === 0
            ) {
                return this.$store.commit("snackbar/open", {
                    text: "Net Exposure Not Found!",
                    color: "error"
                })
            }
            const markets = cloneDeep(this.markets)
            const books = cloneDeep(this.books[market.betfairId])
            const horseArray = books[0].horse
            if (markets && markets?.length > 0 && books) {
                horseArray.sort((a, b) => {
                    return (
                        markets.findIndex((x) =>
                            x.betfairId && a.horse
                                ? x.betfairId.toString() === a.horse.toString()
                                : ""
                        ) -
                        markets.findIndex((x) =>
                            x.betfairId && b.horse
                                ? x.betfairId.toString() === b.horse.toString()
                                : ""
                        )
                    )
                })
                horseArray[1].amount - horseArray[0].amount > 0
                    ? this.calculateCashOut(
                          horseArray[0].amount,
                          horseArray[1].amount,
                          markets[0].batb,
                          "back"
                      )
                    : this.calculateCashOut(
                          horseArray[0].amount,
                          horseArray[1].amount,
                          markets[0].batl,
                          "lay"
                      )
            }
        },
        calculateCashOut(h1, h2, rateList, betType) {
            if (!(rateList && rateList[0] && rateList[1])) {
                return this.$store.commit("snackbar/open", {
                    text: "Rates Not valid!",
                    color: "error"
                })
            }
            const stakeValue = (h2 - h1) / rateList[0][1]
            if (Math.abs(stakeValue) < 1) {
                this.$store.commit("snackbar/open", {
                    text: "Stake value should be greater than 1",
                    color: "error"
                })
                return
            }
            this.$store.commit("placeBet/openPopover", {
                market: this.market,
                runner: this.markets[0],
                allRunners: this.markets,
                oddsIndex: 1,
                odds: this.market.bookMakerCustom
                    ? rateList[0][1]
                    : rateList[0][1],
                type: betType,
                isCashOut: true,
                bettingType:
                    this.market.bookMakerCustom && this.market.isJodiMarket
                        ? "multiHorse"
                        : this.market.bookMakerCustom &&
                          !this.market.isJodiMarket
                        ? "bookmaker"
                        : "default",
                stake: Math.abs(stakeValue.toFixed(2))
            })
        },
        getBooks(books, id) {
            if (
                books &&
                books[this.market.betfairId] &&
                books[this.market.betfairId].length > 0 &&
                (books[this.market.betfairId][0].horse ||
                    books[this.market.betfairId][0].horses)
            ) {
                const horses =
                    books[this.market.betfairId][0].horse ||
                    books[this.market.betfairId][0].horses

                // eslint-disable-next-line array-callback-return
                const value = horses.find((e) => {
                    let horseId = e.horse
                    if (!isString(id)) {
                        horseId = parseInt(horseId)
                    }
                    if (horseId === id) return e
                })
                if (value && value.amount) {
                    return value.amount || ""
                } else {
                    return 0
                }
            } else {
                return 0
            }
        },
        async getMaxBet(markets) {
            let odds
            let bettingRunnerId
            let types
            forEach(markets, function (value) {
                if (!odds && !bettingRunnerId) {
                    forEach(value.batb, function (batb) {
                        if (batb && batb[2] && batb[2] > 0) {
                            bettingRunnerId = value.betfairId
                            odds = batb[2]
                            types = "back"
                        }
                    })
                    forEach(value.batl, function (batl) {
                        if (batl && batl[2] && batl[2] > 0) {
                            bettingRunnerId = value.betfairId
                            odds = batl[0]
                            types = "lay"
                        }
                    })
                }
            })
            if (odds && bettingRunnerId && this.$auth.loggedIn) {
                const minMaxData = {
                    game: upperFirst(this.$route.params.category || "Cricket"),
                    loading: false,
                    oddsSelected: odds,
                    selectionId: bettingRunnerId,
                    type: types,
                    allmaxbets: true,
                    marketId: this.marketId
                }
                await this.$store.dispatch(
                    "matchInside/getMinMaxMarket",
                    minMaxData
                )
                if (
                    !this.minMaxMarket.maxBet ||
                    (this.minMaxMarket &&
                        this.minMaxMarket.maxBet &&
                        this.minMaxMarket.maxBet === 0)
                ) {
                    this.minmax = []
                } else {
                    this.minmax = [
                        {
                            maxBet: this.minMaxMarket.maxBet
                        },
                        {
                            maxBet: this.minMaxMarket.maxBet1
                        },
                        {
                            maxBet: this.minMaxMarket.maxBet2
                        }
                    ]
                }
            }
        },
        xsOnlyOdds(bool, type) {
            if (bool) {
                return [0]
            } else {
                if (type === "back") {
                    return [2, 1, 0]
                }
                return [0, 1, 2]
            }
        },
        getObjValue(object, i, j, output) {
            return object && object.length ? object[i][j] : output
        },
        check(runner, key, i, market) {
            if (
                key === "batb" &&
                market &&
                market.eventType &&
                market.eventType.isMatchOdds
            ) {
                return true
            }
            let result = false
            if (market && market.bookMakerCustom) {
                if (key !== "batl") {
                    i = 2 - i
                }
                result =
                    runner &&
                    runner[key] &&
                    runner[key].length > 0 &&
                    runner[key][0] &&
                    runner[key][0].length > 0 &&
                    runner[key][0][i]
            } else {
                result =
                    runner &&
                    runner[key] &&
                    runner[key].length > 0 &&
                    runner[key][i] &&
                    runner[key][i].length > 0 &&
                    runner[key][i][1]
            }
            return result
        }
    }
}
</script>
<style lang="scss" scoped>
.opacity-0 {
    opacity: 0;
}

.market-down-arrow,
.market-up-arrow {
    position: absolute !important;
    top: 20% !important;
    left: 5px !important;
    z-index: 1 !important;
}
.ranks {
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 0.625rem !important;

    @media only screen and (max-width: 768px) {
        font-size: 0.5rem !important;
    }
}
.subtitle {
    font-size: 0.625rem !important;
    font-weight: 400;

    @media only screen and (max-width: 768px) {
        font-size: 0.5rem !important;
    }
}

.inplay-horse-details {
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0.5rem 1rem;
    border-bottom: 1px solid black;
    font-weight: 700;
    cursor: pointer;
    @media only screen and (max-width: 768px) {
        font-size: 0.725rem !important;
    }
}
.event-spec-text {
    font-size: 0.625rem !important;
    font-weight: 400;
    @media only screen and (max-width: 768px) {
        font-size: 0.5rem !important;
    }
}

.odds-container:last-child {
    .odds-strip:last-child {
        border-bottom-right-radius: 1rem !important;
        border-bottom-left-radius: 1rem !important;
    }
}

.odds-container:last-child .odds-strip:last-child .btn-odds:last-child {
    border-bottom-right-radius: 1rem !important;
}
.odds-container:last-child .odds-strip:last-child .v-overlay {
    border-bottom-right-radius: 1rem !important;
}

.border-radius {
    .odds-strip {
        &:last-child {
            border-bottom: 1px solid black;
        }
    }
}

.border-radius {
    .odds-strip {
        &:last-child {
            border-bottom: 1px solid black;
        }
    }
}
</style>
